import SETTINGS from './settings.gql';

export {
  SETTINGS,
};
